import React from 'react';
import './ContactList.css'; // certifique-se de criar esse CSS ou ajustar no seu global
import { InputText } from "primereact/inputtext";

export default function ContactList({ contacts, onSelect, selectedEmail, naoLidas, search, setSearch }) {
  return (
    <div className="contact-list">
      <h4>Contatos</h4>
      <InputText
        id="search"
        name="search"
        placeholder="Buscar um contato"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="chat-input"
      />
      <ul>
        {contacts.map((contact) => {
          const email = contact.email?.trim();
          const unreadCount = naoLidas?.[email] || 0;
          const isSelected = selectedEmail === email;

          return (
            <li
              key={email}
              onClick={() => onSelect(contact)}
              className={`contact-item ${isSelected ? "selected" : ""}`}
            >
              <div className="contact-info">
                <span className="contact-name">{contact.nome}</span>
                {unreadCount > 0 && (
                  <span className="unread-badge">{unreadCount}</span>
                )}
              </div>
              <small className="contact-email">{email}</small>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
